import { getMantleLogoColor, MANTLE_MARK_PATH, MANTLE_MARK_VIEWBOX_SIZE } from '../components/logos/mantleLogo';

export const getMantleMarkFaviconHref = (): string => {
  const color = getMantleLogoColor();
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${MANTLE_MARK_VIEWBOX_SIZE} ${MANTLE_MARK_VIEWBOX_SIZE}" fill="none"><path d="${MANTLE_MARK_PATH}" fill="${color}"/></svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};
